/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const mediaAttributeSchema = z.enum(['cv'])

export type MediaAttributeSchema = z.infer<typeof mediaAttributeSchema>
